import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import guildActions from '../actions/guild'

export const useGuild = () => {
  const data = useSelector((state) => {
    return get(state, 'app.guildManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(guildActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
